import React from 'react';
import { User } from 'types/user';
import history from 'services/history';
import DataGridList from 'components/data-grid/DataGridList';
import { userTableTamplate } from '../../template/userTableTemplate';

type UserListTableProps = {
  users: User[];
};

const UserListTable: React.FC<UserListTableProps> = ({ users }) => {
  return (
    <DataGridList
      template={userTableTamplate}
      rows={users}
      getRowId={row => row.id}
      onRowClick={row => history.push(`/users/${row.id}`)}
      fileName="usuarios"
      sheetName="Usuários"
    />
  );
};

export default UserListTable;
